module.exports = __webpack_public_path__ + "static/media/clouds_left.16bc01f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/clouds_left.png
// module id = 639
// module chunks = 1